import { render } from "./CrossRefTicket.vue?vue&type=template&id=357a3d96&scoped=true"
import script from "./CrossRefTicket.vue?vue&type=script&lang=js"
export * from "./CrossRefTicket.vue?vue&type=script&lang=js"

import "./CrossRefTicket.vue?vue&type=style&index=0&id=357a3d96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357a3d96"]])

export default __exports__